<template>
    <div class="theme2">
        <!-- Footer -->
        <footer class="theme2-footer">
            <div class="theme2-footer-container">
                <!-- Desktop Layout -->
                <div class="theme2-footer-grid">
                    <!-- Contact Info -->
                    <div class="theme2-footer-section">
                        <h3 class="theme2-footer-title">Contact Us</h3>
                        <div class="theme2-footer-links">
                            <a href="mailto:support@mywingio.com" class="theme2-footer-link">
                                <span>📧</span>
                                <span>support@mywingio.com</span>
                            </a>
                            <a href="tel:+447349970810" class="theme2-footer-link">
                                <span>📞</span>
                                <span>+44 7349 970810</span>
                            </a>
                        </div>
                    </div>

                    <!-- Resources -->
                    <div class="theme2-footer-section">
                        <h3 class="theme2-footer-title">Resources</h3>
                        <div class="theme2-footer-links">
                            <a href="https://www.mywingio.com/how-it-works" target="_blank" class="theme2-footer-link">
                                <span>📱</span>
                                <span>Parent App Guide</span>
                            </a>
                            <a href="https://www.mywingio.com/wingio-child-app" target="_blank" class="theme2-footer-link">
                                <span>👶</span>
                                <span>Kids App Guide</span>
                            </a>
                        </div>
                    </div>

                    <!-- Legal -->
                    <div class="theme2-footer-section">
                        <h3 class="theme2-footer-title">Legal</h3>
                        <div class="theme2-footer-legal">
                            <a href="https://www.mywingio.com/privacy-policy" target="_blank" class="theme2-footer-link">Privacy Policy</a>
                            <span style="color: #6b7280;">•</span>
                            <a href="https://www.mywingio.com/terms-of-service" target="_blank" class="theme2-footer-link">Terms & Conditions</a>
                            <span style="color: #6b7280;">•</span>
                            <a href="https://www.mywingio.com/returns" target="_blank" class="theme2-footer-link">Shipping & Returns</a>
                            <span style="color: #6b7280;">•</span>
                            <a href="https://www.mywingio.com/warranty" target="_blank" class="theme2-footer-link">Warranty</a>
                        </div>
                    </div>
                </div>

                <!-- Mobile Layout -->
                <div class="theme2-footer-mobile">
                    <div class="theme2-footer-section">
                        <h3 class="theme2-footer-title">Contact Us</h3>
                        <div class="theme2-footer-links">
                            <a href="mailto:support@mywingio.com" class="theme2-footer-link">
                                <span>📧</span>
                                <span>support@mywingio.com</span>
                            </a>
                            <a href="tel:+447349970810" class="theme2-footer-link">
                                <span>📞</span>
                                <span>+44 7349 970810</span>
                            </a>
                        </div>
                    </div>

                    <div class="theme2-footer-section">
                        <h3 class="theme2-footer-title">Resources</h3>
                        <div class="theme2-footer-links">
                            <a href="https://www.mywingio.com/how-it-works" target="_blank" class="theme2-footer-link">
                                <span>📱</span>
                                <span>Parent App Guide</span>
                            </a>
                            <a href="https://www.mywingio.com/wingio-child-app" target="_blank" class="theme2-footer-link">
                                <span>👶</span>
                                <span>Kids App Guide</span>
                            </a>
                        </div>
                    </div>

                    <div class="theme2-footer-section">
                        <h3 class="theme2-footer-title">Legal</h3>
                        <div class="theme2-footer-links">
                            <a href="https://www.mywingio.com/privacy-policy" target="_blank" class="theme2-footer-link">Privacy Policy</a>
                            <a href="https://www.mywingio.com/terms-of-service" target="_blank" class="theme2-footer-link">Terms & Conditions</a>
                            <a href="https://www.mywingio.com/returns" target="_blank" class="theme2-footer-link">Shipping & Returns</a>
                            <a href="https://www.mywingio.com/warranty" target="_blank" class="theme2-footer-link">Warranty</a>
                        </div>
                    </div>
                </div>

                <!-- Copyright -->
                <div class="theme2-footer-copyright">
                    <p>© Wingio {{ new Date().getFullYear() }}. All rights reserved</p>
                </div>
            </div>
        </footer>

        <!-- Bottom Navigation (Mobile) -->
        <nav class="theme2-bottom-nav">
            <a 
                href="javascript:void(0)" 
                class="theme2-bottom-nav-item"
                :class="{ 'active': currentRoute === 'Kids Devices' }"
                @click="navigateAndClose('/kids-device')"
            >
                <DashboardIcon :iconClass="{ 'svg-icon-active': currentRoute === 'Kids Devices' }" />
                <span>Dashboard</span>
            </a>
            <a 
                href="javascript:void(0)" 
                class="theme2-bottom-nav-item"
                :class="{ 'active': currentRoute === 'Applications List' || currentRoute === 'Application' }"
                @click="navigateAndClose('/play-store')"
            >
                <ApplicationsIcon :iconClass="{ 'svg-icon-active': currentRoute === 'Applications List' }" />
                <span>Apps</span>
            </a>
            <a 
                href="javascript:void(0)" 
                class="theme2-bottom-nav-item"
                :class="{ 'active': currentRoute === 'requests' }"
                @click="navigateAndClose('/requests')"
            >
                <AppRequestListIcon :iconClass="{ 'svg-icon-active': currentRoute === 'requests' }" />
                <span>Request</span>
            </a>
            <a 
                href="javascript:void(0)" 
                class="theme2-bottom-nav-item"
                :class="{ 'active': showMoreMenu }"
                @click="toggleMoreMenu()"
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" :fill="showMoreMenu ? '#06b6d4' : '#6b7280'"/>
                </svg>
                <span>More</span>
            </a>
        </nav>

        <!-- More Menu Modal -->
        <div v-if="showMoreMenu" class="theme2-modal-overlay show" @click="closeMoreMenu"></div>
        <div class="theme2-modal-panel" :class="{ 'show': showMoreMenu }">
            <div class="theme2-modal-header">
                <h5 class="theme2-modal-title">More Options</h5>
                <button class="theme2-modal-close" @click="closeMoreMenu">✕</button>
            </div>
            <div class="theme2-modal-content">
                <a 
                    href="javascript:void(0)" 
                    class="theme2-modal-item"
                    :class="{ 'active': currentRoute === 'geofence' }"
                    @click="navigateAndClose('/geofence')"
                >
                    <div class="theme2-modal-item-icon">
                        <GeofenceIcon />
                    </div>
                    <div class="theme2-modal-item-text">
                        <div class="theme2-modal-item-title">Location Alerts</div>
                        <div class="theme2-modal-item-subtitle">Manage safe zones</div>
                    </div>
                </a>
                <a 
                    v-if="enableSchedule"
                    href="javascript:void(0)" 
                    class="theme2-modal-item"
                    :class="{ 'active': currentRoute === 'schedule' }"
                    @click="navigateAndClose('/schedule')"
                >
                    <div class="theme2-modal-item-icon">
                        <ScheduleIcon />
                    </div>
                    <div class="theme2-modal-item-text">
                        <div class="theme2-modal-item-title">Schedule</div>
                        <div class="theme2-modal-item-subtitle">Manage schedules</div>
                    </div>
                </a>
                <a 
                    href="javascript:void(0)" 
                    class="theme2-modal-item"
                    :class="{ 'active': currentRoute === 'global-settings' }"
                    @click="navigateAndClose('/global-settings')"
                >
                    <div class="theme2-modal-item-icon">
                        <SettingIcon />
                    </div>
                    <div class="theme2-modal-item-text">
                        <div class="theme2-modal-item-title">Settings</div>
                        <div class="theme2-modal-item-subtitle">App settings</div>
                    </div>
                </a>
                <a 
                    href="javascript:void(0)" 
                    class="theme2-modal-item"
                    :class="{ 'active': currentRoute === 'contacts' }"
                    @click="navigateAndClose('/contacts')"
                >
                    <div class="theme2-modal-item-icon">
                        <AddressBookIcon />
                    </div>
                    <div class="theme2-modal-item-text">
                        <div class="theme2-modal-item-title">Manage Contacts</div>
                        <div class="theme2-modal-item-subtitle">Contact management</div>
                    </div>
                </a>
                <a 
                    href="javascript:void(0)" 
                    class="theme2-modal-item"
                    :class="{ 'active': currentRoute === 'reports' }"
                    @click="navigateAndClose('/reports')"
                >
                    <div class="theme2-modal-item-icon">
                        <ReportIcon />
                    </div>
                    <div class="theme2-modal-item-text">
                        <div class="theme2-modal-item-title">Reports</div>
                        <div class="theme2-modal-item-subtitle">View activity reports</div>
                    </div>
                </a>
                <a 
                    href="javascript:void(0)" 
                    class="theme2-modal-item"
                    :class="{ 'active': currentRoute === 'device-info' }"
                    @click="navigateAndClose('/device-info')"
                >
                    <div class="theme2-modal-item-icon">
                        <DeviceIcon />
                    </div>
                    <div class="theme2-modal-item-text">
                        <div class="theme2-modal-item-title">Device</div>
                        <div class="theme2-modal-item-subtitle">Device information</div>
                    </div>
                </a>
                <a 
                    href="javascript:void(0)" 
                    class="theme2-modal-item"
                    :class="{ 'active': currentRoute === 'browser-logs' }"
                    @click="navigateAndClose('/browser-logs')"
                >
                    <div class="theme2-modal-item-icon">
                        <BrowserLogIcons />
                    </div>
                    <div class="theme2-modal-item-text">
                        <div class="theme2-modal-item-title">Online Safety</div>
                        <div class="theme2-modal-item-subtitle">Web browsing history</div>
                    </div>
                </a>
                <a 
                    href="javascript:void(0)" 
                    class="theme2-modal-item"
                    @click="navigateAndClose('/contact-us')"
                >
                    <div class="theme2-modal-item-icon" style="background: #fef2f2;">
                        <NeedHelpIcon />
                    </div>
                    <div class="theme2-modal-item-text">
                        <div class="theme2-modal-item-title" style="color: #991b1b;">Need a help?</div>
                        <div class="theme2-modal-item-subtitle" style="color: #dc2626;">Contact support</div>
                    </div>
                </a>
                
                <div style="height: 1px; background: #e5e7eb; margin: 0.5rem 1rem;"></div>
                
                <a 
                    href="javascript:void(0)" 
                    class="theme2-modal-item"
                    @click="logout()"
                >
                    <div class="theme2-modal-item-icon" style="background: #fee2e2;">
                        <LogoutIcon />
                    </div>
                    <div class="theme2-modal-item-text">
                        <div class="theme2-modal-item-title" style="color: #dc2626;">Logout</div>
                        <div class="theme2-modal-item-subtitle">Sign out of your account</div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import DashboardIcon from '@/components/icons/DashboardIcon.vue';
import ApplicationsIcon from '@/components/icons/ApplicationsIcon.vue';
import AppRequestListIcon from '@/components/icons/AppRequestListIcon.vue';
import GeofenceIcon from '@/components/icons/GeofenceIcon.vue';
import ScheduleIcon from '@/components/icons/ScheduleIcon.vue';
import SettingIcon from '@/components/icons/SettingIcon.vue';
import ReportIcon from '@/components/icons/ReportIcon.vue';
import DeviceIcon from '@/components/icons/DeviceIcon.vue';
import LogoutIcon from '@/components/icons/LogoutIcon.vue';
import AddressBookIcon from '@/components/icons/AddressBookIcon.vue';
import BrowserLogIcons from '@/components/icons/BrowserLogIcons.vue';
import PaymentHistoryIcon from '@/components/icons/PaymentHistoryIcon.vue';
import PaymentMethodIcon from '@/components/icons/PaymentMethodIcon.vue';
import ChangePasswordIcon from '@/components/icons/ChangePasswordIcon.vue';
import NeedHelpIcon from '@/components/icons/NeedHelpIcon.vue';
import UserService from '@/services/UserService.js';
import KidsService from '@/services/KidsService.js';

export default {
  name: 'KidFooterTheme2',
  components: {
    DashboardIcon,
    ApplicationsIcon,
    AppRequestListIcon,
    GeofenceIcon,
    ScheduleIcon,
    SettingIcon,
    ReportIcon,
    DeviceIcon,
    LogoutIcon,
    AddressBookIcon,
    BrowserLogIcons,
    PaymentHistoryIcon,
    PaymentMethodIcon,
    ChangePasswordIcon,
    NeedHelpIcon
  },
  props: {
    profileId: String,
    serialNumber: String,
  },
  data() {
    return {
      showMoreMenu: false,
      enableSchedule: false,
    }
  },
  computed: {
    currentRoute() {
      return this.$route.name;
    },
    routerName() {
      return this.$route.name;
    }
  },
  methods: {
    toggleMoreMenu() {
      this.showMoreMenu = !this.showMoreMenu;
    },
    closeMoreMenu() {
      this.showMoreMenu = false;
    },
    navigateAndClose(path) {
      this.showMoreMenu = false;
      this.$router.push({ 
        path: path, 
        query: { 
          profileId: this.profileId, 
          serialNumber: this.serialNumber 
        } 
      });
    },
    logout() {
      this.showMoreMenu = false;
      let data = {
        serialNumber: this.serialNumber,
        profileId: this.profileId
      };
      UserService.logout(data)
        .then((response) => {
          localStorage.setItem('token', "");
          localStorage.removeItem('token');
          this.$toast.success(response.data.respones_msg);
          
          if (localStorage.getItem('hideGoogleLogin') == "true") {
            document.location = "/login?hideGBtn=true";
          } else {
            this.$router.push('login');
          }
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async unReadNotificationCount() {
      let data = {
        serialNumber: this.serialNumber,
        profileId: this.profileId
      }
      await KidsService.unReadNotificationCount(data)
      .then((response) => {
        this.enableSchedule = response.data.enableSchedule;
      }).catch((e) => {
        this.$toast.error(e.response.data.respones_msg);
        if (e.response.data.is_logout == true) {
          this.$router.push({ path: '/login'});
        }
      });
    },
  },
  watch: {
    serialNumber() {
      this.unReadNotificationCount();
    },
  },
  mounted() {
    this.unReadNotificationCount();
  },
}
</script>

<style scoped>
/* Component-specific styles if needed */
</style>